import React, { useState, useEffect, useCallback } from "react"
import MyModal from "../MyModal"
import Input from "../Input"
import { getServerPackageList } from "../../services/serverPackagesApis"
import genRandomNumber from "../../utils/genRandomNumber"
import actionHelper from "../../lib/actionHelper"
import { createTsServer } from "../../services/serverApis"
import { toast } from "react-toastify"
import { useSocket, useSocketEvent } from "../../contexts/SocketContext"
import useLivePromise from "../../lib/livePromise"

const CreateServerModal = ({ isOpen, toggleModal }) => {
    const { isConnected, sendMessage } = useSocket()
    const { run } = useLivePromise()

    const [packages, setPackages] = useState(null)
    const [usedPorts, setUsedPorts] = useState(null)
    const [serverportIsValid, setServerportIsValid] = useState(true)
    const [queryportIsValid, setQueryportIsValid] = useState(true)
    const [randomServerPort, setRandomServerPort] = useState(null)
    const [randomQueryPort, setRandomQueryPort] = useState(null)

    const createHandler = (e) => {
        e.preventDefault()
        if (!serverportIsValid || !queryportIsValid) {
            toast.error("پورت نامعتبر است")
        }

        const form = new FormData(e.target)
        let data = {
            serverport: form.get("serverport"),
            queryport: form.get("queryport"),
            packageName: form.get("package-name"),
            version: form.get("version"),
            subdomain: form.get("subdomain-name"),
            information: form.get("information"),
        }

        run({
            job: () => createTsServer(data),
            subscribeEvent: "server_create_progress",
            doneEvent: "server_create_done",
            errorEvent: "server_create_error",
            initialPending: "در حال ارسال درخواست به سرور",
        })
    }

    const handlePackageOnChange = (event) => {
        let packagePriceLabel = document.getElementById("packagePriceLabel")
        const packageName = event.target.value
        const packaage = packages.find((item) => item.package_name === packageName)
        packagePriceLabel.innerHTML = `<div class="show_info text-sm mt-2 text-green-400">${packaage.package_amount.toLocaleString(
            "en-US",
        )} تومان</div>`
    }

    const handleServerportOnChange = (event) => {
        setRandomServerPort(event.target.value)
        var serverportLabel = document.getElementById("serverportLabel")
        var serverPort = event.target.value
        if (usedPorts.includes(parseInt(serverPort)) || serverPort > 7000 || serverPort < 4000) {
            setServerportIsValid(false)
            serverportLabel.innerHTML = '<div class="show_info text-sm text-red-400">نامعتبر</div>'
        } else {
            setServerportIsValid(true)
            serverportLabel.innerHTML = '<div class="show_info text-sm text-green-400">معتبر</div>'
        }
    }
    const handleQueryportOnChange = (event) => {
        setRandomQueryPort(event.target.value)
        var queryportLabel = document.getElementById("queryportLabel")
        var queryPort = parseInt(event.target.value)
        if (usedPorts.includes(parseInt(queryPort)) || queryPort > 7000 || queryPort < 4000) {
            setQueryportIsValid(false)
            queryportLabel.innerHTML = '<div class="show_info text-sm text-red-400">نامعتبر</div>'
        } else {
            setQueryportIsValid(true)
            queryportLabel.innerHTML = '<div class="show_info text-sm text-green-400">معتبر</div>'
        }
    }

    // Create stable callback functions for socket events
    const handleUsedPortsList = useCallback((data) => setUsedPorts(data), [])
    const handleServerPackageList = useCallback((data) => setPackages(data), [])

    // Use the stable callbacks with socket events
    useSocketEvent("usedPortsList", handleUsedPortsList)
    useSocketEvent("serverPackageList", handleServerPackageList)

    useEffect(() => {
        if (isOpen && isConnected) {
            sendMessage("getUsedPorts")
            sendMessage("getServerPackageList")
        }
    }, [isOpen, isConnected])

    useEffect(() => {
        if (usedPorts && isOpen) {
            setRandomQueryPort(genRandomNumber(usedPorts))
            setRandomServerPort(genRandomNumber(usedPorts))
        }
    }, [isOpen, usedPorts])

    return (
        <MyModal isOpen={isOpen} toggleModal={toggleModal} width="400px" height="500px">
            <div className="">
                <form onSubmit={createHandler} className="m-2 ml-2">
                    <div className="mt-2 grid grid-cols-2 gap-x-5">
                        <Input
                            type="number"
                            dir="ltr"
                            label={"سرورپورت"}
                            placeholder={"سرورپورت"}
                            value={randomServerPort}
                            name={"serverport"}
                            onChange={handleServerportOnChange}
                        />

                        <Input
                            type="number"
                            dir="ltr"
                            label={"کوئری پورت"}
                            placeholder={"کوئری پورت"}
                            name={"queryport"}
                            value={randomQueryPort}
                            onChange={handleQueryportOnChange}
                        />
                        <span id="serverportLabel">
                            <div class="show_info text-sm text-green-400">معتبر</div>
                        </span>

                        <span id="queryportLabel">
                            <div class="show_info text-sm text-green-400">معتبر</div>
                        </span>
                    </div>

                    <div className="mt-2">
                        <label className="block">پکیج ها</label>
                        <select class="styled-select" name="package-name" onChange={handlePackageOnChange}>
                            {packages &&
                                packages.map((item, index) => (
                                    <option key={index} value={item.package_name}>
                                        {item.package_description}
                                    </option>
                                ))}
                        </select>
                        <span id="packagePriceLabel">
                            <div class="show_info text-sm mt-2 text-green-400">
                                {packages && packages[0]?.package_amount.toLocaleString("en-US")}
                                تومان
                            </div>
                        </span>
                    </div>
                    <div>
                        <label className="block">ورژن</label>
                        <select class="styled-select" name="version">
                            <option value="1.5.6">TeaSpeak 1.5.6</option>
                            <option value="1.4.22">TeaSpeak 1.4.22</option>
                        </select>
                    </div>
                    <div className="mt-2">
                        <Input
                            type="text"
                            dir="rtl"
                            label={"ساب دامین"}
                            placeholder={"ساب دامین"}
                            name={"subdomain-name"}
                        />
                    </div>
                    <div className="mt-2">
                        <Input type="text" dir="rtl" label={"توضیحات"} placeholder={"توضیحات"} name={"information"} />
                    </div>

                    <button type="submit" className="styled-button w-full mt-5">
                        ساخت سرور
                    </button>
                </form>
            </div>
        </MyModal>
    )
}

export default CreateServerModal
